/*
 * Hide floating chat / support widgets while a drawer (cart, menu) is open.
 *
 * Shopify's newer agent chat button renders inside a shadow DOM
 * (`.activator-nudge` > `button.activator[part="activator"]`), so theme CSS
 * cannot reach it through the shadow boundary and it kept popping over the
 * cart drawer's estimated total / checkout button.
 *
 * The theme adds `overflow-hidden` to <body> whenever a drawer is open, so we
 * watch that class and toggle the widget's host element (found by piercing
 * open shadow roots) between hidden and visible. Restores on drawer close.
 */
(function () {
  var CHAT_SELECTOR =
    '.activator-nudge, .activator[part="activator"], shopify-agent-icon, #shopify-chat, #dummy-chat-button-iframe';

  var widgetHost = null;

  // Depth-first search through the light DOM and any *open* shadow roots.
  function deepFind(root, selector) {
    if (root.querySelector) {
      var direct = root.querySelector(selector);
      if (direct) return direct;
    }
    var nodes = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].shadowRoot) {
        var nested = deepFind(nodes[i].shadowRoot, selector);
        if (nested) return nested;
      }
    }
    return null;
  }

  // Climb out of any shadow roots, then up to the top-level <body> child so we
  // hide the whole widget container, not just the inner button.
  function resolveHost(node) {
    var el = node;
    while (el) {
      var root = el.getRootNode && el.getRootNode();
      if (root instanceof ShadowRoot) {
        el = root.host;
      } else {
        break;
      }
    }
    while (el && el.parentElement && el.parentElement !== document.body) {
      el = el.parentElement;
    }
    return el;
  }

  function sync() {
    if (!widgetHost || !widgetHost.isConnected) {
      var found = deepFind(document, CHAT_SELECTOR);
      widgetHost = found ? resolveHost(found) : null;
    }
    if (!widgetHost) return;

    if (document.body.classList.contains('overflow-hidden')) {
      widgetHost.style.setProperty('display', 'none', 'important');
    } else {
      widgetHost.style.removeProperty('display');
    }
  }

  function start() {
    // React to the drawer opening/closing (body class toggle).
    new MutationObserver(sync).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
    // The chat widget is injected asynchronously; keep looking until we find it.
    new MutationObserver(function () {
      if (!widgetHost || !widgetHost.isConnected) sync();
    }).observe(document.documentElement, { childList: true, subtree: true });
    sync();
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
